import React from 'react';
import Buildings from './buildings';

export default function Dashboard(): JSX.Element {
  return (
    <Buildings />
  );
}
